const safariVersionMatchRegExp = /Version\/(\d*\.\d*)/;
export default function detectSafariVersion() {
    var _a;
    if (typeof window === "undefined" || ((_a = window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) == null) {
        return 0;
    }
    const ua = window.navigator.userAgent;
    const isSafari = ua.indexOf("Safari") !== -1 && ua.indexOf("Chrome") === -1;
    if (isSafari) {
        const safariVersionMatch = ua.match(safariVersionMatchRegExp);
        if (safariVersionMatch && safariVersionMatch.length > 1) {
            return parseInt(safariVersionMatch[1]);
        }
    }
    return 0;
}
